@if (isLoading) {
  <div @fadeInOut class="overlay">
    <div class="content mat-elevation-z8" [class.active]="isVisible">
      <div class="loader-shell">
        <div class="loader-orbit"></div>
        <div class="loader-core">
          @if (spinner) {
            <mat-spinner class="{{ spinner }}"></mat-spinner>
          }
          @if (!spinner) {
            <mat-spinner class="spinner"></mat-spinner>
          }
          <div class="loader-mark">RB</div>
        </div>
      </div>

      <div class="copy">
        <span class="eyebrow">Dental RB Dashboard</span>
        <strong class="title">Procesando información</strong>
        <span class="message">{{ message || 'Preparando los datos para mostrar el contenido.' }}</span>
      </div>
    </div>
  </div>
}
